<br /><br />
<footer class="footer-bs">
  <div class="row">
    <div
      class="col-lg-3 col-xs-6 col-sm-6 col-md-3 footer-social animated fadeInDown"
    >
      <p>Get to know us</p>
      <div class="border"></div>
      <br />
      <ul>
        <li><a href="#">Home</a></li>
        <li><a href="#">About us</a></li>
        <li><a href="#">Privacy policy</a></li>
        <li><a href="#">Our pages</a></li>
        <li><a href="#">Careers</a></li>
      </ul>
    </div>
    <div
      class="col-lg-3 col-xs-6 col-sm-6 col-md-3 footer-social animated fadeInDown"
    >
      <p>Let us help you</p>
      <div class="border"></div>
      <br />
      <ul>
        <li><a href="myaccount">Account</a></li>
        <li><a href="#">Returns</a></li>
        <li><a href="#">Cancelation</a></li>
        <li><a href="#">FAQ</a></li>
        <li><a href="#">Track my order</a></li>
      </ul>
    </div>
    <div
      class="col-lg-3 col-xs-6 col-sm-6 col-md-3 footer-social animated fadeInDown"
    >
      <p>Stay connected</p>
      <div class="border"></div>
      <br />
      <a>Get alerts about on Zero Armario.</a>
      <div style="height: 20px;"></div>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Enter your email"
        />
        <span class="input-group-btn">
          <button class="btn" type="button">
            <i class="bx bx-envelope"></i>
          </button>
        </span>
        <div class="border"></div>
        <div class="social-icons" style="justify-content: space-evenly">
          <a href="#"><i class="bx bxl-facebook bx-xs"></i></a>
          <a href="#"><i class="bx bxl-twitter bx-xs"></i></a>
          <a href="#"><i class="bx bxl-instagram bx-xs"></i></a>
          <a href="#"><i class="bx bxl-youtube bx-xs"></i></a>
        </div>
      </div>
    </div>
    <div
      class="col-lg-3 col-xs-6 col-sm-6 col-md-3 footer-social animated fadeInDown"
    >
      <p>Payment method</p>

      <div class="border"></div>
      <br />
      <div class="float-left" id="pay">
        <img src="../../../assets/images/png/pays.png" width="60%"/>
      </div>
    </div>
  </div>
  <br /><br />
  <br /><br />
  <h3  style="text-align: center; font-size: 12px;">&copy; Spaxe</h3>
</footer>
